export default __webpack_public_path__ + "locales/lo-LA/UploadPanel.json?hash=c214c5ba53fda7a5f29ea5403e6299d1";